<template>
  <div>
    <table
      class="table profile-table table-responsive-lg overflow-y-xs text-small"
    >
      <th>
        {{ $t('cert') }}
      </th>
      <th>
        <div
          class="cell-item  sort-icon"
          @click="toggleOrder('-firstname')"
        >
          <span
            :class="
              orderDirection == 'firstname' || orderDirection == '-firstname'
                ? 'text-primary'
                : ''
            "
          >
            {{ $t('form.lastname') }}
          </span>
          <span
            :class="firstnameDirectionClass"
            class="ml-1"
            @click="toggleOrder('-firstname')"
          ></span>
        </div>
      </th>
      <th>
        <div class="cell-item sort-icon" @click="toggleOrder('-habilitation')">
          <span
            :class="
              orderDirection == 'habilitation' ||
              orderDirection == '-habilitation'
                ? 'text-primary'
                : ''
            "
          >
            {{ $t('qualif') }}
          </span>
          <span
            :class="habilitationDirectionClass"
            class="pl-1 sort-icon"
          ></span>
        </div>
      </th>
      <th>
        <div
          class="cell-item  sort-icon"
          @click="toggleOrder('-issue_date')"
        >
          <span
            :class="
              orderDirection == 'issue_date' || orderDirection == '-issue_date'
                ? 'text-primary'
                : ''
            "
            >{{ $t('validity') }}
          </span>
          <span :class="issueDateDirectionClass" class="ml-2"></span>
        </div>
      </th>
      <th>{{ $t('form.dlv') }}</th>
      <th>{{ $t('ext') }}</th>
      <th>{{ $t('iata') }}</th>
      <tbody class="box-block">
        <habilitation-row
          v-for="(habilitation, index) in habilitationsList"
          :key="habilitation.id"
          :index="index"
          :habilitation="habilitation"
          :user="user"
        ></habilitation-row>
      </tbody>
    </table>
    <UploadModal />
    <PrintModal />
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import HabilitationRow from './HabilitationRow.vue'
import UploadModal from './UploadModal.vue'
import PrintModal from './PrintModal.vue'

export default {
  name: 'HabilitationTable',
  props: {
    habilitationsList: {
      required: true,
      default: [],
      type: Array,
    },
  },
  components: {
    UploadModal,
    PrintModal,
    HabilitationRow,
  },
  computed: {
    ...mapFields([
      'user',
      'habilitations.orderDirection',
      'habilitations.orderBy',
    ]),
    firstnameDirectionClass() {
      if (this.orderDirection == '-firstname') {
        return 'icon icon-sort-down'
      } else return 'icon icon-sort-up'
    },
    habilitationDirectionClass() {
      if (this.orderDirection == '-habilitation') {
        return 'icon icon-sort-down'
      } else return 'icon icon-sort-up'
    },
    issueDateDirectionClass() {
      if (this.orderDirection == '-issue_date') {
        return 'icon icon-sort-down'
      } else return 'icon icon-sort-up'
    },
  },
  methods: {
    toggleOrder(orderBy) {
      this.orderBy = orderBy
      if (this.orderDirection == orderBy) {
        this.orderDirection = orderBy.substring(1)
      } else {
        this.orderDirection = orderBy
      }
    },
  },
}
</script>

<style scoped>
/* th{
  display: flex;
  justify-content: space-between;
  align-items: center;
} */
.table th {
  padding: 0.75rem;
  vertical-align: middle;
  font-size: 0.9rem;
  border-top: 1px solid #dee2e6;
}
.sort-icon:hover {
  cursor: pointer;
}
</style>
